import script from "./TelegramHome.vue?vue&type=script&setup=true&lang=js"
export * from "./TelegramHome.vue?vue&type=script&setup=true&lang=js"

import "./TelegramHome.vue?vue&type=style&index=0&id=0edd9b64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0edd9b64"]])

export default __exports__